export default "__VITE_ASSET__bL$lJQGo__"